<template>
  <div>
    <footer class="footer" style="height: 36px; padding: 0 30px 0 12px;" v-if="lumbredocs_v3">
      <div class="d-flex justify-content-between align-items-center h-100">
        <a :href="creatorUrl" target="_blank">
          <img :src="$store.state.settings.logoLumbreDocs" style="height: 40px; margin-top:-3px" height="40px" alt="Logo" class="py-2" v-if="!isOnMesaContext">
        </a>
        <p class="mb-0 pr-0 d-none d-md-block">
          {{ (new Date()).getFullYear() }} © <a :href="creatorUrl" target="_blank">Lumile</a> {{lumbreVersion}}
        </p>
      </div>
    </footer>
    <footer class="footer" v-else>
      <div class="container-fluid">
        <div class="row">
          <p class="col-12 mb-0">
            {{ (new Date()).getFullYear() }} © <a :href="creatorUrl" target="_blank">Lumile</a> {{lumbreVersion}}
          </p>
        </div>
      </div>
    </footer>
    <nav class="nav">
      <ul class="shadow" v-if="menuItems.length > 0">
        <li v-for="(item, index) in menuItems" :key="'menuItems'+index" v-if="index < 4">
          <router-link :to="item.path ? item.path : '/'">
            <span class="icon"><i :class="item.icon" /></span>
            <div class="name">{{ item.name }}</div>
         </router-link>
        </li>
         <li v-if="menuItems.length > 3" @click="toggleMenu">
            <span class="icon"><i class="mdi mdi-menu"></i></span>
            <!-- <div class="name">Menu</div> -->
        </li>
      </ul>
    </nav>
    <div class="menu" :class="{ collapsed: collapsed }">
      <ul>
        <li v-for="(item, index) in menuItems" :key="'mItems'+index" @click="toggleMenu">
          <router-link :to="item.path ? item.path : '/'">
            <span class="icon"><i :class="item.icon" /></span>
            <div class="name">{{ item.name }}</div>
          </router-link>
        </li>
        <li v-if="settingsItem" @click="toggleSetting">
          <a href="javascript:void(0)">
            <span class="icon"><i :class="settingsItem.icon" /></span>
            <div class="name">{{ settingsItem.name }}</div>
          </a>

          <div class="scrollable" :class="{ collapsedSetting: collapsedSetting }">
            <router-link
              v-for="item of settingsItem.childs"
              :key="item.index"
              class="menu-item"
              :to="item.path"
            >
              <div class="menu-item-content" @click="toggleMenu">
                <span class="icon pl-4"><i :class="item.icon" /></span>
                <span class="text">{{ item.name }}</span>
              </div>
            </router-link>
          </div>
        </li>
      </ul>

      <div v-if="!settingsItem" class="admin-menu-content">
        <li class="menu-item" ref="submenuButton">
          <div class="menu-item-content">
            <span class="icon"><i :class="settingsItem.icon" /></span>
            <span class="text">{{ settingsItem.name }}</span>
          </div>
        </li>
        <div class="submenuMobile" ref="submenu" >
          <div class="scrollable" :class="{ collapsed: collapsedSetting }">
            <router-link
              v-for="item of settingsItem.childs"
              :key="item.index"
              class="menu-item"
              :to="item.path"
            >
              <div class="menu-item-content">
                <span class="icon"><i :class="item.icon" /></span>
                <span class="text">{{ item.name }}</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { version } from '../../package.json'
import { mapState, mapGetters } from 'vuex'

export default {
  inject: ['lumbredocs_v3'],
  computed: {
    ...mapState('session', ['bVersion']),
    ...mapGetters('settings', [
      'menuItems',
      'settingsItem'
    ]),
    lumbreVersion () {
      let version
      if (this.bVersion) {
        version = `(${this.appVersion} - Engine: ${this.bVersion})`
      } else {
        version = `(v${this.appVersion})`
      }
      return version
    }
  },
  data () {
    return {
      appVersion: version,
      isOnMesaContext: process.env?.VUE_APP_LUMBREDOCS_V3_MESA === 'yes',
      creatorUrl: process.env?.VUE_APP_LUMBREDOCS_CREATOR_URL || 'https://www.lumile.com.ar',
      collapsed: true,
      collapsedSetting: true
    }
  },
  methods: {
    toggleMenu () {
      this.collapsed = !this.collapsed
    },
    toggleSetting () {
      this.collapsedSetting = !this.collapsedSetting
    }
  }
}
</script>

<style lang="sass" scoped>
  .footer
    position: fixed;
    width: 100%;
    bottom: 0;
    border-top: 1px solid rgba(152,166,173,.3)
    padding: 19px 30px 20px
    color: $mutedFontThemeColor
    background: #fafbfe
    z-index: 1000;
    @media(max-width: $lg)
      display: none
  .nav
    position: fixed
    bottom: 0
    width: 100%
    z-index: 5000;
    ul
      display: flex
      background: #fff
      width: 100%
      @media(min-width: $lg)
        display: none
      li
        display: flex
        padding: 0.6em 0.8em 1em 0.8em
        flex-direction: column
        justify-content: center
        align-items: center
        flex-grow: 1;
        flex-basis: 0;
        border-top: 1px solid rgba(152, 166, 173, 0.3);
        border-left: 1px solid rgba(152, 166, 173, 0.3);
        text-align: center
        font-size: 14px !important
        color: #444
        flex: 1;
        .name
          color: #999
          font-size: 11px
          line-height: 1.2em
          width: 84px
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 0 auto
        .icon
          font-size: 1.2em
      @media(max-width: $md)
        li:nth-child(4)
          display: none
      @media(max-width: 374px)
        li:nth-child(3)
          display: none
  .menu
    position: fixed
    top: 65px
    width: 100%
    height: calc(100% - 63px - 65px)
    background: #fff
    z-index: 5000
    display: flex
    justify-content: flex-start
    align-items: flex-start
    visibility: true
    opacity: 1
    transform: translateX(0)
    transition: all 0.3s ease
    overflow: auto
    @media(min-width: $lg)
      display: none
    ul
      width: 100%
      li a
        display: flex
        justify-content: flex-start
        align-items: center
        padding: 1em
        border-bottom: 1px solid rgba(152, 166, 173, 0.3);
        .icon
          margin-right: 1em
          margin-top: -5px
    &.collapsed
      opacity: 0
      visibility: false
      transform: translateX(-50px)
      z-index: -1
  .scrollable
    display: initial
    &.collapsedSetting
      display: none

</style>
